"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpApiUrl = void 0;
const Settings_1 = require("./Settings");
class HttpApiUrl {
    static assembleUrl(url, queryParams, settings) {
        var _a;
        Object.keys(settings).forEach((key) => {
            const storedValue = Settings_1.Setting.extract(settings[key]);
            if (typeof storedValue === "string" && storedValue !== "") {
                const placeholder = new RegExp(`{{${key}}}`, "gi");
                url = url.replace(placeholder, storedValue);
            }
        });
        if (url.includes("{{")) {
            return null;
        }
        const urlParts = url.split("?");
        const params = ((_a = urlParts[1]) !== null && _a !== void 0 ? _a : "").split("&").filter(n => n);
        let reqOk = true;
        queryParams.map((param) => {
            if (settings[param.name] !== undefined) {
                const storedValue = Settings_1.Setting.extract(settings[param.name]);
                if (typeof storedValue !== "string")
                    return;
                if (storedValue !== "" || !param.skipEmpty) {
                    let value = Settings_1.Setting.extract(typeof param.value === "string" ? param.value : param.value[storedValue]);
                    if (typeof value !== "string")
                        return;
                    if (value !== "" || !param.skipEmpty) {
                        value = value.replace(new RegExp("{{value}}", "gi"), storedValue);
                        params.push(value);
                    }
                }
            }
            else if (param.required) {
                reqOk = false;
            }
        });
        if (reqOk) {
            return urlParts[0] + (params.length > 0 ? "?" + params.join("&") : "");
        }
        else {
            return null;
        }
    }
}
exports.HttpApiUrl = HttpApiUrl;
